module.exports = __webpack_public_path__ + "img/sv2.cd254a0.png";